import request from "@utils/request";
import { ParamsProps, ReturnType } from "./types";

const getProvinces = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `addressess/provinces`,
      method: "get",
      config: {
        showErr: true,
        store: {
          key: args?.state,
          action: "set",
        },
      },
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};
const getDistrictsByProvince = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `addressess/districts`,
      method: "get",
      params: args?.params,
      config: {
        showErr: true,
        store: {
          key: args?.state,
          action: "set",
        },
      },
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};
const getMunicipalitiesByDistrict = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `addressess/municipals`,
      method: "get",
      params: args?.params,
      config: {
        showErr: true,
        store: {
          key: args?.state,
          action: "set",
        },
      },
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};

export default {
  getProvinces,
  getDistrictsByProvince,
  getMunicipalitiesByDistrict,
};
